import { UploadChangeParam } from 'antd/es/upload/interface';

export const getFile = (e: UploadChangeParam) => {
  return Array.from(e.fileList).map((file) => file?.originFileObj);
};
